import tventas from '../tventas/tventas.vue'



export default {
  name: "contenedor",
  data() {
    return {

    };
  },
  mounted: function () {
    console.log("hei: " + window.innerHeight)
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    console.log("hei2: " + window.innerHeight);
  },
  components: {
    tventas
  },
  computed: {
    currentdate: function () {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    }
  }

};



// WEBPACK FOOTER //
// ./src/components/reportes/cuponesLiqDet/contenedor/contenedor.js